export const DOWNLOADING_PDF = 'toolbarComponent.downloadingPDF'
export const TOGGLE_SOCIAL_MEDIA_BUTTON_DIALOG_OPEN = 'toolbarComponent.toggleSocialMediaButtonDialogOpen'

export function downloadingPDF(payload: any) {
  return {
    type: DOWNLOADING_PDF,
    payload
  } as const
}

export function toggleSocialMediaButtonDialogOpen(payload: boolean) {
  return {
    type: TOGGLE_SOCIAL_MEDIA_BUTTON_DIALOG_OPEN,
    payload
  } as const
}

export type ToolbarAction = ReturnType<typeof downloadingPDF | typeof toggleSocialMediaButtonDialogOpen>
